import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { PrivacySettingVisibility } from '../../../../App.types'
import { Localized } from '../../../../localization/react'

import { visibilityTypeDescriptionTranslation, visibilityTypeTranslation } from './PrivacySettingButton.constants'

interface Props {
  visibility: PrivacySettingVisibility
}

const VisibilityTypeContent = ({ visibility }: Props) => {
  return (
    <Stack gap={0.5} p={3} width="100%">
      <Text variant="badge">
        <Localized id={visibilityTypeTranslation[visibility]} />
      </Text>
      <Text variant="xsmall">
        <Localized id={visibilityTypeDescriptionTranslation[visibility]} />
      </Text>
    </Stack>
  )
}

export default VisibilityTypeContent
